import { useEffect } from "react";
import { useApi } from "@/lib/api";
import { BillingPeriod } from "@/types/billing";

const BILLING_REFRESH_EVENT = "billing:refresh";

/** Call after any mutation that changes the billing stage or period. */
export function emitBillingRefresh() {
  window.dispatchEvent(new CustomEvent(BILLING_REFRESH_EVENT));
}

export function useBillingPeriod(periodId: string | null) {
  return useApi<BillingPeriod>(periodId ? `/api/billing/period/${periodId}` : null, [periodId]);
}

export function useCurrentBillingPeriod() {
  const result = useApi<BillingPeriod>("/api/billing/period");
  useEffect(() => {
    const handler = () => result.refetch();
    window.addEventListener(BILLING_REFRESH_EVENT, handler);
    return () => window.removeEventListener(BILLING_REFRESH_EVENT, handler);
  // result.refetch is stable (same dispatch ref) — intentionally omitted from deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return result;
}
